"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _coder_props = require("./coder_props");

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Coder =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Coder, _PureComponent);

  function Coder(props) {
    var _this;

    _classCallCheck(this, Coder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Coder).call(this, props)); // 生成对应的id

    _this.id = (0, _spauiUtils.getUniqueId)('spaui-coder');

    _this.nullList();

    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.windowResize = _this.windowResize.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Coder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // 延迟点计算，因为如果在弹框里面，可能这个还没有到渲染的时候
      setTimeout(function () {
        _this2.genLineNumberHTML();

        _this2.setCoderHeight();
      }, 4);
      (0, _index.addResize)(this.windowResize);

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      setTimeout(function () {
        _this3.genLineNumberHTML();

        _this3.setCoderHeight();
      }, 4);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
      (0, _index.removeResize)(this.windowResize);
    } // 声明以及一些引用的回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.textareaRef = null;
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        textarea: this.textareaRef || null
      };
    }
  }, {
    key: "windowResize",
    value: function windowResize() {
      this.genLineNumberHTML();
      this.setCoderHeight();
    } // 获取文案的宽度

  }, {
    key: "getWidth",
    value: function getWidth(text) {
      var $div = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementById("".concat(this.id, "-string-width"));
      var result = 0;

      if ($div) {
        $div.innerText = text;
        result = parseInt((0, _spauiUtils.getStyle)($div, 'width'), 10) || 0;
      }

      return result;
    } // 获取行数

  }, {
    key: "getLines",
    value: function getLines() {
      var _this4 = this;

      var _this$props$value = this.props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;
      var result = [];
      var textAreaWidth = 0;
      var valueArr = [];

      if (this.textareaRef) {
        // 获取输入框的宽度
        textAreaWidth = parseInt((0, _spauiUtils.getStyle)(this.textareaRef, 'width'), 10) || 0;
        textAreaWidth = textAreaWidth - parseInt((0, _spauiUtils.getStyle)(this.textareaRef, 'paddingLeft'), 10) || 0;
        textAreaWidth = textAreaWidth - parseInt((0, _spauiUtils.getStyle)(this.textareaRef, 'paddingRight'), 10) || 0;
        textAreaWidth = textAreaWidth - 2;
        valueArr = value.split('\n');
        valueArr.map(function (item) {
          var strWidth = _this4.getWidth(item);

          var strLines = 1;
          var i = 1;
          result.push(true); // 计算字符串在输入框占多少宽度

          if (item && strWidth > 0 && textAreaWidth > 0) {
            strLines = Math.ceil(strWidth / textAreaWidth);
            i = 1;

            for (; i < strLines; i++) {
              result.push(false);
            }
          }

          return item;
        });
      }

      return result;
    } // 生成行数html

  }, {
    key: "genLineNumberHTML",
    value: function genLineNumberHTML() {
      var $id = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementById(this.id);
      var lines = this.getLines();
      var lineHtml = [];
      var i = 1;

      if ($id) {
        lineHtml.push('<div>');
        lines.map(function (item) {
          if (item) {
            lineHtml.push("<i>".concat(i, "</i>"));
            i += 1;
          } else {
            lineHtml.push('<i></i>');
          }

          return item;
        });
        lineHtml.push('</div>');
        $id.innerHTML = lineHtml.join('');
      }
    } // 获取尾部的高度

  }, {
    key: "getFooterContentHeight",
    value: function getFooterContentHeight() {
      var FooterComponent = this.props.FooterComponent;
      var $content = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementById("".concat(this.id, "-content"));
      var $footerContent = null;
      var result = 0; // 有组件的时候才有内容结构

      if ($content && typeof FooterComponent !== 'undefined' && $content.getElementsByTagName('div')) {
        $footerContent = $content.getElementsByTagName('div')[1];

        if ($footerContent) {
          result = parseFloat((0, _spauiUtils.getStyle)($footerContent, 'height'), 10) || 0;
        }
      }

      return result;
    } // 设置对应的高度

  }, {
    key: "setCoderHeight",
    value: function setCoderHeight() {
      var _this$props = this.props,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          FooterComponent = _this$props.FooterComponent;
      var $id = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementById(this.id);
      var $content = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementById("".concat(this.id, "-content"));
      var $parent = $id && $id.parentNode;
      var $line = $id && $id.getElementsByTagName('div')[0];
      var minHeight = parseFloat(style.minHeight, 10) || 0;
      var footerContentHeight = this.getFooterContentHeight();
      var parentRect = {};
      var parentHeight = 0;
      var lineRect = {};
      var lineHeight = {};
      var coderHeight = 0;
      var $textareaContent = null;

      if ($id) {
        if (typeof FooterComponent !== 'undefined') {
          $textareaContent = $content.getElementsByTagName('div')[0];
        }

        if ($parent && !minHeight) {
          parentRect = $parent.getBoundingClientRect();
          parentHeight = parentRect.height;
        } else {
          parentHeight = minHeight;
        }

        if (typeof FooterComponent !== 'undefined') {
          parentHeight = parentHeight - footerContentHeight;
        }

        if ($line) {
          lineRect = $line.getBoundingClientRect();
          lineHeight = lineRect.height;

          if ($id) {
            lineHeight += parseInt((0, _spauiUtils.getStyle)($id, 'paddingTop'), 10) || 0;
            lineHeight += parseInt((0, _spauiUtils.getStyle)($id, 'paddingBottom'), 10) || 0;
          }
        }

        if (parentHeight && lineHeight) {
          if (parentHeight > lineHeight) {
            coderHeight = parentHeight - 2;
            $parent.style.overflow = '';
          } else {
            coderHeight = lineHeight;
            $parent.style.overflow = 'auto';
          }

          if (typeof FooterComponent !== 'undefined') {
            $id.style.height = "".concat(coderHeight + footerContentHeight, "px");
            $textareaContent.style.height = "".concat(coderHeight, "px");
          } else {
            $id.style.height = "".concat(coderHeight, "px");
            $content.style.height = "".concat(coderHeight, "px");
          }
        }
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, event.target.value);
      }
    }
  }, {
    key: "genFooter",
    value: function genFooter() {
      var _this$props2 = this.props,
          FooterComponent = _this$props2.FooterComponent,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          footerClassName = _this$props2.footerClassName;
      var result = null;

      if (typeof FooterComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(FooterComponent)) {
          result = FooterComponent;
        } else {
          result = _react["default"].createElement("div", {
            className: "spaui-coder-foot ".concat(footerClassName)
          }, _react["default"].createElement(FooterComponent, {
            placeholder: placeholder,
            value: value,
            disabled: disabled
          }));
        }
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          placeholder = _this$props3.placeholder,
          value = _this$props3.value,
          disabled = _this$props3.disabled;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-coder'
      }, Coder), _react["default"].createElement("div", {
        className: "spaui-coder-line",
        id: this.id
      }), _react["default"].createElement("div", {
        className: "spaui-coder-content",
        id: "".concat(this.id, "-content")
      }, _react["default"].createElement("div", {
        className: "spaui-coder-textarea"
      }, _react["default"].createElement("textarea", {
        className: "spaui-input spaui-coder-text",
        value: value,
        placeholder: placeholder,
        onChange: this.handleChange,
        ref: function ref(el) {
          _this5.textareaRef = el;
        },
        disabled: disabled
      }), _react["default"].createElement("span", {
        id: "".concat(this.id, "-string-width"),
        className: "spaui-coder-string-width",
        style: {
          position: 'fixed',
          top: '-9999px',
          left: '-9999px',
          height: '1px'
        }
      })), this.genFooter()));
    }
  }]);

  return Coder;
}(_react.PureComponent); // 组件标记


_defineProperty(Coder, "propTypes", _coder_props.propTypes);

_defineProperty(Coder, "defaultProps", _coder_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Coder, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Coder;
exports["default"] = _default;